export class Application {

	sendRequest(parent)
	{
		let _this = this;
		let form = $(parent);
		let button = form.find('button[type=submit]');
		button.attr('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=51",
			type: 'POST',
			data: form.serialize() + '&action=sendRequest',
			dataType: "json",
			success: function(res){
				button.attr('disabled', false);

				if (res.success)
				{
					_this.hideMistake(form);
					$('.application').replaceWith(res.html);
					eval($(res.html).find('script').html());
					/*$('html, body').animate({
						scrollTop: $('.application__wrapper').offset().top
					}, 400);*/
				}
				else
				{
					_this.showMistake(form, 'Ошибка: ' + res.error);
				}
			},
			error: function(res){
				button.attr('disabled', false);
				_this.showMistake(form, 'Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	showMistake(block, text)
	{
		alert(text);
		$(block).find('.form__mistakes p').text(text);
		$(block).find('.form__mistakes').show();
	}

	hideMistake(block)
	{
		$(block).find('.form__mistakes p').text('');
		$(block).find('.form__mistakes').hide();
	}
}
